// Consecutive Size Block - Yobe Kids
(function() {
  const SIZE_ORDERS = [
    // Children's age sizes
    ['newborn','0-3m','3-6m','6-9m','9-12m','12-18m','18-24m'],
['1-2y','3-4y','5-6y','7-8y','9-10y','11-12y','13-14y','15-16y','17-18y','19-20y'],
    // Standard sizes
    ['xs','s','m','l','xl','xxl','xxxl','2xl','3xl','4xl'],
    // Numeric sizes
    ['2','4','6','8','10','12','14','16','18','20'],
    // Single year sizes (odd sizes 1y-7y)
['1y','2y','3y','4y','5y','6y','7y'],
  ];

function getSizeIndex(variantTitle) {
  if (!variantTitle) return null;
  const lower = variantTitle.toLowerCase().replace(/\s/g, '');

  for (let listIdx = 0; listIdx < SIZE_ORDERS.length; listIdx++) {
    const list = SIZE_ORDERS[listIdx];
    // Exact match only
    let idx = list.findIndex(s => lower === s);
    if (idx !== -1) return { listIdx, idx };
  }

  // Fallback: partial match only for hyphenated ranges (e.g. '1-2y')
  for (let listIdx = 0; listIdx < SIZE_ORDERS.length; listIdx++) {
    const list = SIZE_ORDERS[listIdx];
    if (!list[0].includes('-')) continue; // skip non-hyphenated lists
    let idx = list.findIndex(s => lower.includes(s));
    if (idx !== -1) return { listIdx, idx };
  }

  return null;
}

  function hasConsecutiveSizes(cartItems) {
    const productMap = {};
    cartItems.forEach(item => {
      const pid = item.product_id;
      const result = getSizeIndex(item.variant_title);
      if (!result) return;
      const key = `${pid}-${result.listIdx}`;
      if (!productMap[key]) productMap[key] = [];
      if (!productMap[key].includes(result.idx)) productMap[key].push(result.idx);
    });

    for (const key in productMap) {
      const indices = productMap[key].sort((a, b) => a - b);
      for (let i = 0; i < indices.length - 1; i++) {
        if (indices[i + 1] - indices[i] === 1) return true;
      }
    }
    return false;
  }

  function showError(btn) {
    let msg = document.getElementById('consec-size-error');
    if (!msg) {
      msg = document.createElement('p');
      msg.id = 'consec-size-error';
      msg.style.cssText = 'color:red;font-size:13px;margin:8px 0;text-align:center;';
      btn.parentNode.insertBefore(msg, btn);
    }
    msg.textContent = 'لا يمكنك طلب مقاسين متتاليين من نفس المنتج. يرجى اختيار مقاس واحد. / You cannot order two consecutive sizes of the same product.';
  }

  function removeError() {
    const msg = document.getElementById('consec-size-error');
    if (msg) msg.remove();
  }

  function attachCheckoutGuard() {
    document.querySelectorAll('[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout').forEach(btn => {
      if (btn.dataset.consecGuard) return;
      btn.dataset.consecGuard = '1';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            if (hasConsecutiveSizes(cart.items)) {
              showError(btn);
            } else {
              removeError();
              window.location.href = '/checkout';
            }
          });
      }, true);
    });
  }

  document.addEventListener('DOMContentLoaded', attachCheckoutGuard);
  const observer = new MutationObserver(attachCheckoutGuard);
  observer.observe(document.body, { childList: true, subtree: true });
})();
